export function getTenantIdFromRoute(route) {
	if (!route) return null;

	if (route.params && route.params.tenantId) {
		return Array.isArray(route.params.tenantId) ? route.params.tenantId[0] : route.params.tenantId;
	}

	const path = route.path || route.fullPath;
	if (!path) return null;

	const match = path.match(/^\/tenants\/([^/?#]+)/i);
	return match ? decodeURIComponent(match[1]) : null;
}

export function tenantIdsMatch(left, right) {
	if (!left || !right) return false;
	return left.toString().toLowerCase() === right.toString().toLowerCase();
}

export function buildTenantFormSubmissionPath(tenantId, submissionId) {
	return `/tenants/${tenantId}/forms/submissions/${submissionId}`;
}
